import { render, staticRenderFns } from "./LaporanLoyalitasSelect.vue?vue&type=template&id=24171993&scoped=true"
import script from "./LaporanLoyalitasSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./LaporanLoyalitasSelect.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LaporanLoyalitasSelect.vue?vue&type=style&index=0&id=24171993&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24171993",
  null
  
)

export default component.exports